import { GetOffersProposalResponse } from "../crefazService/getOffersProposal";
import { MakeProposalPayload } from "../crefazService/makeProposal";
import { httpClient } from "../http/httpClient";

export interface MakeProposalCrefazPayload extends MakeProposalPayload {
  linkName: string;
  city?: string;
  state?: string;
  leitura?: string;
  rota?: string;
}

export type MakeProposalCrefazResponse = GetOffersProposalResponse & {
  propostaId: string;
};

export async function makeProposalCrefaz(payload: MakeProposalCrefazPayload) {
  const { linkName, cpf, ...providerData } = payload;

  const { data } = await httpClient
    .patch<MakeProposalCrefazResponse>(`/self-hire/${linkName}/simulate`, {
      type: "CREFAZ",
      cpf,
      providerData,
    })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
